import React, { Component } from 'react'

class NotAllowed extends Component {
  render () {
    return (
      <div>
        <h3>Atención!<br />
          <br />
          Usted no esta autorizado a ver este contenido<br />
          Comuniquese con sistemas.
        </h3>
      </div>
    )
  };
};

export default NotAllowed
